var $95c066bb46089c22$exports = {};
$95c066bb46089c22$exports = {
    "replaceMessage": `Kukuta fail asendamiseks`
};


export {$95c066bb46089c22$exports as default};
//# sourceMappingURL=et-EE.mjs.map
